"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _typography = require("../../theme/base/typography");
const baseStyle = {
  lineHeight: 1.5,
  fontWeight: _typography.fontWeights.semibold
};
const variants = exports.variants = {
  h1: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes['2xl'],
      desktop: _typography.fontSizes['3xl']
    }
  },
  h2: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.xl,
      desktop: _typography.fontSizes['2xl']
    }
  },
  h3: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.lg,
      desktop: _typography.fontSizes.xl
    }
  },
  h4: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.base,
      desktop: _typography.fontSizes.lg
    }
  },
  h5: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.base,
      desktop: _typography.fontSizes.base
    }
  },
  h6: {
    ...baseStyle,
    fontSize: {
      base: _typography.fontSizes.sm,
      desktop: _typography.fontSizes.sm
    }
  }
};
const defaultProps = {
  variant: variants.h2
};
var _default = exports.default = {
  variants,
  baseStyle,
  defaultProps
};